/**
 * Service to warm up the backend on first load
 * Calls a cheap health endpoint in the background to wake up the service
 * This hides the cold start from the main user interaction
 * 
 * Render free tier can take 10-30+ seconds on cold start, so we wait up to 30s
 */

import { getApiUrl } from "./api";

const WARMUP_TIMEOUT = 45000; // Render free tier cold starts can be slow.

/**
 * Warm up the backend by calling the health endpoint
 * Returns a promise that resolves when the service is ready or timeout is reached
 */
export const warmupBackend = async () => {
  const startTime = Date.now();
  
  return new Promise((resolve) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
      const elapsed = Date.now() - startTime;
      console.log(`Backend warmup timeout after ${elapsed}ms - proceeding anyway`);
      controller.abort();
      resolve();
    }, WARMUP_TIMEOUT);

    fetch(getApiUrl("/health"), {
      method: "GET",
      signal: controller.signal,
      cache: "no-store",
    })
      .then((response) => {
        clearTimeout(timeoutId);
        const elapsed = Date.now() - startTime;
        if (response.ok) {
          console.log(`Backend warmed up successfully in ${elapsed}ms`);
        } else {
          console.warn(`Backend warmup returned ${response.status} after ${elapsed}ms`);
        }
        resolve();
      })
      .catch((error) => {
        clearTimeout(timeoutId);
        const elapsed = Date.now() - startTime;
        console.warn(`Backend warmup failed after ${elapsed}ms (continuing anyway):`, error);
        resolve();
      });
  });
};
